import {
	LOGIN_USER,
	LOGIN_USER_SUCCESS,
	LOGIN_USER_FAIL,
	LOGIN_USER_CHECK,
	LOGOUT_USER_SUCCESS
} from '../actions/types';

const INITIAL_STATE = { 
	email: '', 
	password: '', 
	user: null,
	errorLogin: '',
	// isLogin: false,
	loading: false,
	userData: '',
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case LOGIN_USER:
			return { ...state, loading: true }
		case LOGIN_USER_SUCCESS:
			return { ...state, ...INITIAL_STATE };
		case LOGIN_USER_FAIL:
			return { ...state, errorLogin: 'Authentication Failed.', password: '', loading: false };
		case LOGIN_USER_CHECK:
			return { ...state, user: action.payload };
		case LOGOUT_USER_SUCCESS:
			return { ...state, ...INITIAL_STATE };
		default:
			return state;
	}
}